import React, { useState, useEffect } from "react";
import { BASE_URL } from "../env";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import filterFactory, {
	textFilter,
	selectFilter,
	multiSelectFilter,
} from "react-bootstrap-table2-filter";
import ToolkitProvider, {
	CSVExport,
	Search,
} from "react-bootstrap-table2-toolkit";
import Select from "react-select";
import { developAxios } from "../axios.config";

const { SearchBar } = Search;
const { ExportCSVButton } = CSVExport;

const AllenrolledStudents = () => {
	const [courseData, setCourseData] = useState([]);
	const [tableData, setTableData] = useState([]);
	const [selectedOption, setSelectedOption] = useState([]);
	const [course, setCourse] = useState([]);
	const [sn, setSn] = useState(1);

	// useEffect(() => {
	//   fetch(BASE_URL + "/admin/dashboard/get-students-in-courses")
	//     .then((res) => res.json())
	//     .then((data) => {
	//       console.log(data, "this is data");
	//       setCourseData(data?.data);
	//     });
	// }, []);

	useEffect(() => {
		developAxios(localStorage.getItem("token"))
			.get("/getallCourse")
			.then(({ data }) => {
				let temp = [];

				for (let i = 0; i < data.courses.length; i++) {
					temp.push({
						value: data.courses[i]._id,
						label: data.courses[i].name,
					});
				}
				setSelectedOption(temp);
			})
			.catch((err) => {
				console.log(err.response);
			});
	}, []);

	useEffect(() => {
		let courseId = [];
		for (let i = 0; i < course.length; i++) {
			courseId.push(course[i].value);
		}
		developAxios(localStorage.getItem("token"))
			.post("/admin/dashboard/get-students-in-courses", {
				courseIds: courseId,
			})
			.then(({ data }) => {
				setCourseData(data);
			})
			.catch((e) => {
				console.log(e);
			});
	}, [course]);

	// let newdata = [];
	// console.log(courseData);

	// useEffect(() => {
	//   for (var i = 0; i < courseData.length; i++) {
	//     let s = courseData[i]?.uploadtime.split("T")[1];
	//     newdata.push({
	//       sno: i + 1,
	//       id: courseData[i]?._id,
	//       coursename: courseData[i]?.coursename,
	//       coupon: courseData[i]?.coupon,
	//       email: courseData[i]?.email,
	//       name: courseData[i]?.name,
	//       uploaddate: courseData[i]?.uploadtime.split("T")[0],
	//       uploadtime: s.slice(0, -1),
	//     });
	//   }
	//   settabledata(newdata);
	//   console.log(JSON.stringify(newdata));
	// // }, [courseData]);
	// useEffect(() => {
	//   let newData = [];
	//   for (let i = 0; i < courseData.length; i++) {
	//     for (let j = 0; j < courseData[i].students.length; j++) {
	//       // console.log(courseData[j].students[j].user.email);
	//       newData.push({
	//         sno: i + 1,
	//         courseId: courseData[i]?.courseId,
	//         _id: courseData[j].students[j]?.user._id,
	//         email: courseData[j].students[j]?.user.email,
	//         firstName: courseData[j].students[j]?.user.firstName,
	//         lastName: courseData[j].students[j]?.user.lastName,
	//         numLogin: courseData[j].students[j]?.user.numLogin,
	//       });
	//     }
	//   }

	//   settabledata(newData);
	//   // // setSelectedOption(newdata);
	// }, [course]);

	useEffect(() => {
		let newData = [];
		for (let i = 0; i < courseData.length; i++) {
			for (let j = 0; j < courseData[i].students.length; j++) {
				newData.push({
					sno: newData.length + 1,
					_id: courseData[i].students[j]?.user?._id,
					email: courseData[i].students[j]?.user?.email,
					firstName: courseData[i].students[j]?.user?.firstName,
					lastName: courseData[i].students[j]?.user?.lastName,
					numLogin: courseData[i].students[j]?.user?.numLogin,
				});
			}
		}
		console.log(newData, "ye hai course data");
		setTableData(newData);
	}, [courseData]);

	let priceFilter;

	const columns = [
		{
			dataField: "sno",
			text: "S no.",
			sort: true,
			headerStyle: () => {
				return {
					width: "5%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
			filter: textFilter({
				getFilter: (filter) => {
					priceFilter = filter;
				},
			}),
		},
		{
			dataField: "firstName",
			text: "firstName",
			sort: true,
			filter: textFilter(),
			headerStyle: () => {
				return {
					width: "10%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
		},
		{
			dataField: "email",
			text: "Email",
			sort: true,
			filter: textFilter(),
			headerStyle: () => {
				return {
					width: "10%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
		},
		{
			dataField: "lastName",
			text: "lastName",
			sort: true,
			headerStyle: () => {
				return {
					width: "5%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
			filter: textFilter({
				getFilter: (filter) => {
					priceFilter = filter;
				},
			}),
		},
		{
			dataField: "numLogin",
			text: "numLogin",
			sort: true,
			filter: textFilter(),
			headerStyle: () => {
				return {
					width: "10%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
		},
		// {
		//   dataField: "numLogin",
		//   text: "numLogin",
		//   sort: true,
		//   filter: textFilter({
		//     getFilter: (filter) => {
		//       priceFilter = filter;
		//     },
		//   }),
		//   headerStyle: () => {
		//     return {
		//       width: "10%",
		//       backgroundColor: "#133d6a",
		//       textAlign: "center",
		//     };
		//   },
		// },
		// {
		//   dataField: "uploadtime",
		//   text: "Upload Time",
		//   sort: true,
		//   filter: textFilter({
		//     getFilter: (filter) => {
		//       priceFilter = filter;
		//     },
		//   }),
		//   headerStyle: () => {
		//     return {
		//       width: "10%",
		//       backgroundColor: "#133d6a",
		//       textAlign: "center",
		//     };
		//   },
		// },
	];

	const [rowcount, setRowcount] = useState(tableData.length);
	const handleDataChange = ({ dataSize }) => {
		setRowcount(dataSize);
	};

	const numberStyle = {
		border: "2px solid black",
		boxShadow: "4px 4px rgba(93, 93, 93)",
		borderRadius: "20px",
		fontFamily: "Poppins-Bold",
		color: "white",
	};

	return (
		<>
			<div className="text-centre my-5">
				<h1
					style={{
						fontFamily: "Poppins-Bold",
						color: "#185adb",
						textAlign: "center",
					}}
				>
					All Student Details
				</h1>
			</div>

			<div className="mx-2 w-25 p-3 bg-dark " style={numberStyle}>
				Row Count:<span style={{ color: "yellow" }}>{rowcount}</span>
			</div>
			<div className="text-center my-5">
				<ToolkitProvider
					keyField={"sno"}
					data={tableData}
					columns={columns}
					exportCSV={{
						fileName: "scores_results.csv",
						blobType: "text/csv;charset=ansi",
						onlyExportFiltered: true,
						exportAll: false,
					}}
					search
				>
					{(props) => (
						<div>
							<ExportCSVButton
								{...props.csvProps}
								className="btn btn-md bg-warning my-2"
								style={{ borderRadius: "10px" }}
							>
								Download All Data
							</ExportCSVButton>
							{/* <hr /> */}
							<br />
							<div></div>
							<SearchBar {...props.searchProps} />
							<br /> <br /> <br /> <br /> <br />
							<label htmlFor="Coursename">
								Choose the course
							</label>
							<Select
								isMulti
								name="Coursename"
								options={selectedOption}
								className="basic-multi-select"
								classNamePrefix="select"
								onChange={(values) => setCourse(values)}
								value={course}
							/>
							<br /> <br /> <br /> <br /> <br />
							<br />
							<br />
							<BootstrapTable
								{...props.baseProps}
								filter={filterFactory()}
								onDataSizeChange={handleDataChange}
								pagination={paginationFactory()}
								bootstrap4
								loading
								// classes="text-white"
								striped
							/>
						</div>
					)}
				</ToolkitProvider>
			</div>
		</>
	);
};

export default AllenrolledStudents;
